var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoBbDk(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "bb_logo",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 131.15 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "logo_bb_dk") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M73.5,9.4h0l-.2-.3a2.5,2.5,0,0,1-.8-1.8,2.19,2.19,0,0,1,2.4-2,2.29,2.29,0,0,1,2.5,2.1c0,1.4-1.4,2.1-1.4,2.2l1.1,1.1a4.18,4.18,0,0,0,.4-1c.1-.3.1-.5.5-.3l.9.3c.3.1.2.4.2.6a10.43,10.43,0,0,1-.8,1.6l1.1,1c.2.1.3.3,0,.6l-.7.7a.45.45,0,0,1-.6,0l-.8-.8a3.47,3.47,0,0,1-2.7,1A2.51,2.51,0,0,1,71.9,12,2.72,2.72,0,0,1,73.5,9.4Zm1.2,3.3a1.38,1.38,0,0,0,1.3-.6l-1.6-1.7a1.38,1.38,0,0,0-.9,1.3A1.2,1.2,0,0,0,74.7,12.7Zm1-5.3a.88.88,0,0,0-.9-.8c-.5,0-.7.3-.7.6s.2.6.6,1l.3.3C74.9,8.5,75.7,8.1,75.7,7.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.6,18.1h5.6a.32.32,0,0,0,.3-.3V16.1a.32.32,0,0,0-.3-.3H72.6a.32.32,0,0,0-.3.3v1.7Q72.45,18.1,72.6,18.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.59,5.2l3.29,9.28L39.14,5.2h3.47V18H40V14.5l.27-6L36.77,18H35L31.52,8.47l.26,6V18H29.14V5.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.25,18a3,3,0,0,1-.25-.85,3.11,3.11,0,0,1-2.4,1,3.4,3.4,0,0,1-2.32-.81,2.6,2.6,0,0,1-.91-2A2.68,2.68,0,0,1,45.49,13a5.51,5.51,0,0,1,3.23-.82h1.17v-.54a1.6,1.6,0,0,0-.33-1.06,1.36,1.36,0,0,0-1.07-.39,1.54,1.54,0,0,0-1,.3,1.07,1.07,0,0,0-.36.85H44.58a2.56,2.56,0,0,1,.51-1.53,3.4,3.4,0,0,1,1.44-1.11,5.37,5.37,0,0,1,2.09-.4,4.15,4.15,0,0,1,2.79.89,3.07,3.07,0,0,1,1,2.48V15.8a4.52,4.52,0,0,0,.38,2.05V18Zm-2.1-1.77a2.16,2.16,0,0,0,1-.25,1.57,1.57,0,0,0,.7-.67V13.68h-1c-1.27,0-1.94.44-2,1.31v.15a1,1,0,0,0,.33.79A1.31,1.31,0,0,0,48.15,16.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.74,10.87a8.36,8.36,0,0,0-.92-.07,1.87,1.87,0,0,0-1.89,1V18H54.39V8.49h2.4l.07,1.13A2.36,2.36,0,0,1,59,8.31a2.52,2.52,0,0,1,.79.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.41,14.19l-.91.91V18H61V4.5H63.5V12l.49-.63,2.44-2.86h3l-3.44,4L69.77,18H66.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.14,18V5.2h4.48a5.85,5.85,0,0,1,3.54.9,3,3,0,0,1,1.2,2.61,2.92,2.92,0,0,1-.48,1.66,2.86,2.86,0,0,1-1.35,1.05,2.68,2.68,0,0,1,1.56,1,3,3,0,0,1,.56,1.83A3.35,3.35,0,0,1,89.47,17a5.22,5.22,0,0,1-3.35,1Zm2.64-7.44h2c1.33,0,2-.55,2-1.59a1.47,1.47,0,0,0-.51-1.25,2.71,2.71,0,0,0-1.6-.38H83.78Zm0,1.87v3.45H86a2.2,2.2,0,0,0,1.45-.44A1.54,1.54,0,0,0,88,14.21a1.61,1.61,0,0,0-1.82-1.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.07,13.16a5.7,5.7,0,0,1,.54-2.53,4.12,4.12,0,0,1,1.57-1.71,4.63,4.63,0,0,1,2.38-.61A4.35,4.35,0,0,1,99.7,9.49a4.77,4.77,0,0,1,1.36,3.2l0,.65a4.94,4.94,0,0,1-1.23,3.51,4.2,4.2,0,0,1-3.27,1.33,4.29,4.29,0,0,1-3.29-1.32,5.1,5.1,0,0,1-1.22-3.59Zm2.54.18a3.55,3.55,0,0,0,.51,2.07,1.67,1.67,0,0,0,1.46.72A1.7,1.7,0,0,0,98,15.42a3.94,3.94,0,0,0,.52-2.27A3.58,3.58,0,0,0,98,11.09a1.71,1.71,0,0,0-1.46-.73,1.65,1.65,0,0,0-1.44.73A3.94,3.94,0,0,0,94.61,13.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105,8.49l.08,1.1a3.32,3.32,0,0,1,2.73-1.28A2.76,2.76,0,0,1,110,9.2a4.15,4.15,0,0,1,.76,2.66V18h-2.54V11.92a1.7,1.7,0,0,0-.35-1.18,1.61,1.61,0,0,0-1.17-.36,1.74,1.74,0,0,0-1.61.91V18h-2.54V8.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.33,13.17a5.76,5.76,0,0,1,1-3.54,3.25,3.25,0,0,1,2.73-1.32,2.94,2.94,0,0,1,2.3,1V4.5h2.55V18h-2.3l-.12-1A3,3,0,0,1,116,18.18a3.23,3.23,0,0,1-2.7-1.33A5.88,5.88,0,0,1,112.33,13.17Zm2.54.19a3.79,3.79,0,0,0,.46,2.06,1.53,1.53,0,0,0,1.36.71,1.7,1.7,0,0,0,1.66-1V11.38a1.68,1.68,0,0,0-1.65-1C115.48,10.38,114.87,11.38,114.87,13.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.24,18.18a4.64,4.64,0,0,1-3.4-1.29,4.53,4.53,0,0,1-1.32-3.42v-.24a5.7,5.7,0,0,1,.56-2.56,4,4,0,0,1,1.56-1.74A4.4,4.4,0,0,1,127,8.31,3.93,3.93,0,0,1,130,9.54,5,5,0,0,1,131.15,13v1H125.1a2.39,2.39,0,0,0,.74,1.5,2.27,2.27,0,0,0,1.57.56,2.73,2.73,0,0,0,2.29-1.07l1.25,1.4a3.8,3.8,0,0,1-1.55,1.26A5.1,5.1,0,0,1,127.24,18.18ZM127,10.36a1.61,1.61,0,0,0-1.23.51,2.72,2.72,0,0,0-.6,1.47h3.54v-.2a1.92,1.92,0,0,0-.46-1.31A1.64,1.64,0,0,0,127,10.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5,25A12.5,12.5,0,1,1,25,12.5,12.5,12.5,0,0,1,12.5,25Zm0-24A11.57,11.57,0,0,0,1,12.5,11.57,11.57,0,0,0,12.5,24,11.57,11.57,0,0,0,24,12.5,11.63,11.63,0,0,0,12.5,1Z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12.5,
    y: 12,
    width: 12,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 12,
    width: 6,
    height: 1
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "4.4 3.7 21.3 20.6 20.6 21.3 3.6 4.4 4.4 3.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1.9 7.2 17.8 23.1 17.1 23.8 1.2 7.9 1.9 7.2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 0.5,
    width: 1,
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17.5,
    y: 1.9,
    width: 1,
    height: 10.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 12.5,
    width: 1,
    height: 10.4
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoBbDk);
export default __webpack_public_path__ + "static/media/logo_bb_dk.e07c0dd5022e075db5aac088384494cf.svg";
export { ForwardRef as ReactComponent };